'use strict';

const AncillariesModuleGrafanaConstants = require('./ancillaries_module_grafana_constants');
const priceManagerCollection = require('../../modules/collections/pricemanager.collection').getInstance();
const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection').getInstance();

module.exports = function(childModel, collectionViewClass) {
    Odigeo.defineWidget('ancillaries_module', Odigeo.Widget.extend({
        collectionClass: require('./ancillaries_module.collection.model'),
        viewClass: collectionViewClass,

        tracking: require('../../tracking/ancillaries')('guarantees'),

        init: function() {
            this.options = Odigeo.parseOptions(this.options);

            this.collectionClass = this.collectionClass.extend({
                model: childModel,
            });
        },

        fetchData: function(page) {
            this.pageToTrack = Odigeo._.isEmpty(page) ? this.options.page.toUpperCase() : page.toUpperCase();
            this.collection.setUrl(page);
            this.collection.fetchData();
        },

        clearData(baggageData = {}) {
            this.collection.reset();
            this.collection.loadBags(baggageData);
        },

        validateSelection: function(skipNagWhenAnyProductIsSelected) {
            return this.collection.validateSelection(skipNagWhenAnyProductIsSelected);
        },

        showContinueNag: function() {
            this.collection.showContinueNag();
        },

        getAddedPolicies: function() {
            return this.collection.getAddedPolicies();
        },

        trackPrimeContinue: function() {
            this.view._childViews.map((ancillaryView) => {
                if (ancillaryView.trackEvent) {
                    ancillaryView.trackEvent();
                }
            });
        },

        updateProductsStateOverRadicalShoppingCartAndContinue: function(nextPage) {
            return this.collection.updateProductsStateOverRadicalShoppingCartAndContinue(nextPage);
        },

        toggleAncillaryOfferIfExists(policy, selected) {
            this.toggleAncillaryOffer(policy, selected);
        },

        removeFlexInsuranceFromCache() {
            this.collection.removeFlexInsuranceFromCache();
        },

        toggleAncillaryOffer: function(policy, selected) {
            this.collection.toggleAncillaryOffer(policy, selected);
        },

        getLoadMetricKey: function() {
            return AncillariesModuleGrafanaConstants.getLoadMetricKey(this.pageToTrack);
        },

        getErrorMetricKey: function() {
            return AncillariesModuleGrafanaConstants.getErrorMetricKey(this.pageToTrack);
        },

        rejectSelectionForUnSelectedSingleProducts: function() {
            this.collection.rejectSelectionForUnSelectedSingleProducts();
        },

        showPendingDecisionError: function() {
            this.collection.showPendingDecisionError();
        },

        onCollectionLoaded(callback) {
            Promise.all(this.getCollectionPromises()).then(callback);
        },

        getCollectionPromises() {
            return [
                priceManagerCollection,
                insuranceCatalogueCollection,
                this.collection,
            ].map((collection) => collection.getLoadedPromise());
        },

        refresh() {
            return this.collection.refresh();
        },

        getPolicies() {
            this.collection.getPolicies();
        },

        trackBaggage(baggageData = {}) {
            const hasAutoCheckinProduct = baggageData?.hasAutoCheckin;

            if (hasAutoCheckinProduct && Odigeo.Utils.isDesktop()) {
                const {allPieces} = baggageData;
                if (allPieces === 0) {
                    Odigeo.once(this.tracking.onloadCheckin());
                }
            }
        },
    }));
};
